"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = __importDefault(require("styled-components"));
var Checkbox_styled_1 = __importDefault(require("../checkbox/Checkbox.styled"));
var MultiCheckboxWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", " {\n    margin-top: 1.6rem;\n\n    margin-left: ", ";\n\n    :first-of-type {\n      margin-top: ", ";\n    }\n  }\n"], ["\n  ", " {\n    margin-top: 1.6rem;\n\n    margin-left: ", ";\n\n    :first-of-type {\n      margin-top: ", ";\n    }\n  }\n"])), Checkbox_styled_1.default, function (props) { return (props.hasLegend ? "1.6rem" : 'unset'); }, function (props) { return (props.hasLegend ? "0.4rem" : 'unset'); });
exports.default = MultiCheckboxWrapper;
var templateObject_1;
//# sourceMappingURL=MultiCheckbox.styled.js.map